<template>
  <div>
    <div class="bigQuery-title">
      <div>{{ $t("RAM.GCP.BigQuery.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:bigQuery:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:bigQuery:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="bigQuery-top">
      <big-query-search ref="bigQuerySearchChild"></big-query-search>
    </div>
    <table-big-query></table-big-query>
  </div>
</template>

<script>
import BigQuerySearch from "../bigQuery/BigQuerySearch";
import TableBigQuery from "../bigQuery/TableBigQuery";

export default {
  name: "BigQuery",
  components: {
    BigQuerySearch,
    TableBigQuery
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.bigQuerySearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 402,
          accountType: 4
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.bigQuerySearchChild.companyId;
      this.accountIds = this.$refs.bigQuerySearchChild.accountIds;
      this.volumeAwsId = this.$refs.bigQuerySearchChild.volumeAwsId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGCPBigQuery({
          // "accountName": this.accountNameSearchID,
          companyId: this.companyId,
          accountName: this.accountName,
          name: this.name
        })
        .then(res => {
          let fileName = "BigQuery.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.bigQuery-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.bigQuery-title > div:nth-child(1) {
  float: left;
}
.bigQuery-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.bigQuery-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/bigQuery/BigQuery.vue